import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  ${(p) =>
    p.img &&
    `
        background-image: url('/a/${p.img}');
        background-repeat:no-repeat;
        background-position:center;
        background-size: cover;
    `}

  ${(p) => p.inlineCSS}
`;

const withFluidWrapper = (Component) => (props) => {
  const { extra = {} } = props;
  const { withFluidWrapper, className, css, src } = extra;

  if (withFluidWrapper) {
    return (
      <Wrapper
        img={src}
        inlineCSS={css}
        className={`sp-container-wrapper ${className}`}
      >
        <Component {...props} noInlineCSS={true} />
      </Wrapper>
    );
  } else {
    return <Component {...props} />;
  }
};

export default withFluidWrapper;
